import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../../../../../PracticeReseveContext';
import PracticeReserveSituationLineLabel from './label/PracticeReserveSituationLineLabel';
import PracticeReserveSituationLineBatch from './batch/PracticeReserveSituationLineBatch';
import PracticeReserveSituationLineRadioBtn from './radioBtn/PracticeReserveSituationLineRadioBtn';


// シチュエーションごと:選択行
function PracticeReserveSituationCaseCategoryLine(props: any) {

  const { user } = useContext(PracticeReseveContext);

  const category = props.category;
  const info = props.info;
  const isBusiness = props.isBusiness;
  const isPronunciation = props.isPronunciation;

  const [isDisabled, setIsDisabled] = useState(false);


  useEffect(() => {
    setIsDisabled(isBusiness || isPronunciation);
  }, [category])


  return (
    <li
      key={info.id}
      className="list-group-item"
      style={isDisabled? { backgroundColor: '#eeeeee' } : undefined}
    >
      {/* シチュエーション各行で表示するラベル：ミッション・台本 */}
      <PracticeReserveSituationLineLabel
        info={info}
        isDisabled={isDisabled}
      />

      <label
        htmlFor={`situation_${category}_${info.id}`}
        style={{width: '90%', height: '100%', cursor: 'pointer',}}
      >

        {info.situation}

        {/* 各種バッチ */}
        <PracticeReserveSituationLineBatch
          info={info}
        />

        {isDisabled && (
          <span
            className="pull-right"
            style={{fontWeight: 'normal', fontSize: '90%',}}
          >選択出来ません</span>
        )}
      </label>

      {/* シチュエーション各行で表示するラジオボタン */}
      <PracticeReserveSituationLineRadioBtn
        category={category}
        info={info}
        isDisabled={isDisabled}
      />

    </li>
  );
}
  
export default PracticeReserveSituationCaseCategoryLine;